module.exports = __webpack_public_path__ + "static/media/group-active-code.e8129f54.png";